import {Component, Inject, Input, OnInit} from '@angular/core';
import {Document} from "../../interface/document";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {JobResultDialogData} from "../job-result-dialog/job-result-dialog.component";
import {Job} from "../../interface/job";


export interface DocumentPreviewDialogData {
  document: Document;
}

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss']
})
export class DocumentPreviewComponent implements OnInit {
  document?: Document;
  type: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DocumentPreviewDialogData,
  ) {
    this.document = data.document;
    this.type = this.getFileType(this.document.filename);
  }

  ngOnInit(): void {

  }

  getFileType(filename: string) {
    const extension = filename.split('.').pop().toLowerCase();
    const types = {
      'jpg': 'Image',
      'jpeg': 'Image',
      'png': 'Image',
      'gif': 'Image',
      'pdf': 'pdf',
      'doc': 'Document',
      'docx': 'Document',
      'xls': 'Spreadsheet',
      'xlsx': 'Spreadsheet',
      'ppt': 'Presentation',
      'pptx': 'Presentation',
      'txt': 'Text',
      // dodaj inne typy w razie potrzeby
    };
    return types[extension] || 'Unknown';
  }
}
